import React, { useEffect, useState } from "react";
import { STUDENT_DETAILS_FORM_HEADER } from "../../constants/text_constants";
import FormHeader from "../Login/FormHeader";
import InputField from "../InputField-Component/InputField";
import SelectField from "./SelectField";
import SubmitButton from "./SubmitButton";
import useCountriesData from "../../utils/use-countriesData";
import useStatesData from "../../utils/use-statesData";
import useCitiesData from "../../utils/use-citiesData";
import BG_IMAGE from "../../assets/BG_IMAGE.jpg";

const StudentDetailsForm = ({ showTitle, btnText }) => {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [emailError, setEmailError] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [pinCode, setPinCode] = useState("");
  const countriesData = useCountriesData();
  const statesData = useStatesData(selectedCountry?.id);
  const citiesData = useCitiesData(selectedState?.id);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetail"));

  const email = userDetails?.userEmail;
  const phone = userDetails?.userMobile;



  const validateEmail = (value) => {
  setUserEmail(value);

  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!regex.test(value)) {
    setEmailError("Please enter a valid email");
  } else {
    setEmailError("");
  }
};


  useEffect(() => {
    if (email) {
      setUserEmail(email);
    }
    if (phone) {
      setUserMobile(phone);
    }
  }, []);

  return (
    <div
      style={{
        fontFamily: "DM Sans",
        fontStyle: "normal",
        lineHeight: "normal",
      }}
      className="mt-[2rem]"
    >
      <div className="mx-auto w-full max-w-[28rem] px-4">
      {showTitle && (
        <div className="lg:mt-[3rem] mt-[2.3rem]">
          <FormHeader title={STUDENT_DETAILS_FORM_HEADER} />
        </div>
      )}
      <div className="lg:my-6 my-3">
        <div className="grid grid-cols-1 lg:gap-4 gap-2">
          <InputField
            id={"user-name"}
            type={"text"}
            text={"Full Name"}
            placeHolder={"John Doe"}
            setValue={setUserName}
            width={"w-full"}
          />
          {!email &&
            <InputField
              id={"user-email"}
              type={"email"}
              text={"Email"}
              placeHolder={"abc@example.com"}
              setValue={validateEmail}
              width={"w-full"}
            />
          }
          {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
          {!phone &&
            <InputField
              id={"user-phone"}
              type={"number"}
              text={"Phone Number"}
              placeHolder={"1234567890"}
              setValue={setUserMobile}
              width={"w-full"}
            />
          }
          <InputField
            id={"user-address"}
            type={"text"}
            text={"Address"}
            placeHolder={
              "Maecenas finibus risus purus, et condimentum arcu viverra"
            }
            setValue={setUserAddress}
            width={"w-full"}
          />
          <div className="grid grid-cols-2 lg:gap-4 gap-2 mt-4">
            <SelectField
              text={"Country"}
              value={selectedCountry}
              setValue={setSelectedCountry}
              data={countriesData}
              labelText={"Countries"}
              width={"w-full"}
            />
            {selectedCountry && (
              <SelectField
                text={"State"}
                value={selectedState}
                setValue={setSelectedState}
                data={statesData}
                labelText={"States"}
                width={"w-full"}
              />
            )}
            {selectedState && (
              <SelectField
                text={"City"}
                value={selectedCity}
                setValue={setSelectedCity}
                data={citiesData}
                labelText={"Cities"}
                width={"w-full"}
              />
            )}
            {selectedState && (
              <InputField
                id={"user-address-pincode"}
                type={"text"}
                text={"Pincode"}
                placeHolder={"Pincode"}
                setValue={setPinCode}
                width={"w-full"}
              />
            )}
          </div>
        </div>


        <SubmitButton
          userName={userName}
          userEmail={userEmail}
          userMobile={userMobile}
          userAddress={userAddress}
          country={selectedCountry}
          state={selectedState}
          city={selectedCity}
          pincode={pinCode}
          btnText={btnText}
        />
      </div>
      {/* <div
        style={{
          backgroundImage: `url('${BG_IMAGE}')`,
          backgroundSize: "cover",
          backgroundPosition: "bottom right",
        }}
        className = "h-[8rem] w-[15rem] absolute -bottom-1.5 right-0 md:block hidden"
      ></div> */}
    </div>
    </div>
  );
};

export default StudentDetailsForm;
